import { createElement, type ReactNode } from 'react';
import { type TFunction } from 'i18next';
import { resolveListingDataValue, type ListingEnergyDescriptor } from '@pkgs/components/utils/listingDataUtils';
import { EnergyClassLabelMap } from '@pkgs/components/consts/countryData';
import { CountryCode, isKey, type Listing } from '@pkgs/api';

import { EnergyEfficiencyPopup } from '@/components/property-expose/EnergyEfficiencyPopup/EnergyEfficiencyPopup';

type ListingDataTranslationResolver = TFunction<'listing_data'>;

export const getEnergyContent = ({
  descriptor,
  listing,
  t,
}: {
  descriptor: ListingEnergyDescriptor;
  listing: Listing;
  t: ListingDataTranslationResolver;
}): ReactNode => {
  const energyClass = descriptor.value;
  const isEnergyClassNormalizedField = descriptor.fieldName === 'energyClassNormalized';
  const doesKeyExistInEnergyClasses = energyClass && isKey(EnergyClassLabelMap, energyClass);

  if (isEnergyClassNormalizedField && doesKeyExistInEnergyClasses) {
    return createElement(EnergyEfficiencyPopup, {
      energyClass,
      listingCountryCode: listing.countryAlpha2 ?? CountryCode.DE,
    });
  }

  return resolveListingDataValue(descriptor, t);
};
